import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocalisation } from '@3plearning/lingui-cdn';

import {
  Root,
  PanelWrapper,
  CollapsedPanel,
  ExpandedPanel
} from './styled';

import { groupAssignAndUnAssignAssignmentsSelector } from './selectors';
import getTranslations from './translations';

import ResizeIcon from './resize-icon';
import AssignButton from "./assign-button";
import UnassignButton from "./unassign-button";


const Footer = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const prevSelectedAssignmentsCount = useRef(0);

  const { selectedCellsCount } = useSelector(groupAssignAndUnAssignAssignmentsSelector);

  const { i18n } = useLocalisation();
  const { CELLS_SELECTED_TEXT, CELL_SELECTED_TEXT } = getTranslations({ i18n });

  const manageCollapsed = () => {
    const firstAssignmentSelected = prevSelectedAssignmentsCount.current === 0 && selectedCellsCount > 0;
    const lastAssignmentDeselected = prevSelectedAssignmentsCount.current > 0 && selectedCellsCount === 0;

    if (firstAssignmentSelected) {
      setIsCollapsed(false);
    } else if (lastAssignmentDeselected) {
      setIsCollapsed(true);
    }

    prevSelectedAssignmentsCount.current = selectedCellsCount;
  }

  useEffect(() => {
    manageCollapsed();
  }, [selectedCellsCount, prevSelectedAssignmentsCount]);

  return (
    <Root isCollapsed={isCollapsed}>
      <ResizeIcon isCollapsed={isCollapsed} onClickCallback={setIsCollapsed} />

      <PanelWrapper>
        {isCollapsed && (
          <CollapsedPanel data-testid="footer-collapsed-panel">
            {`${selectedCellsCount} ${selectedCellsCount > 1 ? CELLS_SELECTED_TEXT : CELL_SELECTED_TEXT}`}
          </CollapsedPanel>
        )}

        {!isCollapsed && (
          <ExpandedPanel data-testid="footer-expended-panel">
            <UnassignButton />
            <AssignButton />
          </ExpandedPanel>
        )}
      </PanelWrapper>
    </Root>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./components/footer/index.js